// frontend/src/components/assessment/panels/ConversationPanel.js
// Left panel of the assessment two-panel layout.
// Reuses MessageList and ChatInput unchanged. ChatHeader is now rendered once,
// full-width, by the parent AssessmentView (matching RoleplayView's layout).

// import React from 'react';
import PropTypes from 'prop-types';
import MessageList from '../MessageList';
import ChatInput from '../ChatInput';

const ConversationPanel = ({ messages, onSendMessage, isThinking }) => {
  return (
    <div className="conversation-panel">
      <MessageList messages={messages} isThinking={isThinking} />
      <ChatInput onSendMessage={onSendMessage} />
    </div>
  );
};

ConversationPanel.propTypes = {
  messages: PropTypes.array.isRequired,
  onSendMessage: PropTypes.func.isRequired,
  isThinking: PropTypes.bool,
};

ConversationPanel.defaultProps = {
  isThinking: false,
};

export default ConversationPanel;
